import React from 'react'
import { compareAsc, compareDesc } from 'date-fns'

// Icons
import Archive from '@material-ui/icons/Archive'
import Business from '@material-ui/icons/Business'
import Grain from '@material-ui/icons/Grain'
import People from '@material-ui/icons/People'
import ShowChart from '@material-ui/icons/ShowChart'

// Screens
// import CourseList from '../views/CourseList'
// import ProviderList from '../views/ProviderList'

// Lazy loaded screens
import asyncComponent from '../components/AsyncComponent'
const CourseList = asyncComponent(() => import('../views/CourseList'))
const ProviderList = asyncComponent(() => import('../views/ProviderList'))
const Dashboard = asyncComponent(() => import('../views/Dashboard'))
const DataGenerator = asyncComponent(() => import('../views/DataGenerator'))

// Navigation Settings
export const routes = [
  {
    title: 'Home',
    path: '/',
    exact: true,
    redirect: '/courses'
  },
  {
    title: 'Dashboard',
    path: '/dashboard',
    Screen: Dashboard,
    icon: <ShowChart />
  },
  {
    title: 'Courses',
    path: '/courses',
    icon: <People />,
    Screen: CourseList,
    filter: course => !course.archive,
    sort: (a, b) => compareAsc(a[1].date, b[1].date)
  },
  {
    title: 'Providers',
    path: '/providers',
    Screen: ProviderList,
    icon: <Business />
  },
  {
    title: 'Course Archive',
    path: '/archive',
    Screen: CourseList,
    icon: <Archive />,
    filter: course => course.archive,
    sort: (a, b) => compareDesc(a[1].date, b[1].date),
    readOnly: true
  },
  {
    title: 'Data Generator',
    path: '/generator',
    Screen: DataGenerator,
    icon: <Grain />
  }
]



// WEBPACK FOOTER //
// ./src/constants/routes.jsx